import React from "react";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/ButtonBase";

import TextTruncater from "../../TextTruncater";
import Currency from "../../Currency";
import CellActivitiesDetails from "./Details";
import GroupTitle from "../../GroupTitle";
import SpotlioIcon from "../../Icon";
import Drawer from "../../Drawer";
import MobileMessage from "../../MobileMessage";

import "./index.scss";

import {
  getSystemSettings,
  getDestination,
} from "../../../utils/SettingsRetriever";
import IntlMessage from "../../../LocaleEngine";
import TaxesAndFeesText from "../../../utils/taxesAndFees";

export default class CellActivities extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: 0,
    };

    this.supplierPricing = {
      primaryPrice: {
        type: "FromPrice",
      },
      upperPrice: {
        type: "Savings",
        timeSpan: "label",
      },
    };

    if (
      props.configuration &&
      props.configuration.config &&
      props.configuration.config.supplierPricing
    ) {
      this.supplierPricing = props.configuration.config.supplierPricing;
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.loadingCart === "finished" &&
        this.props.loadingCart === false) ||
      (prevProps.bundleStatus &&
        prevProps.bundleStatus[prevProps.bundleStatus.length - 1] === false &&
        this.props.bundleStatus[this.props.bundleStatus.length - 1] ===
          undefined)
    ) {
      if (this.props.open === this.props.index) {
        this.setDrawerOpen();
      }
    }
  }

  openIfMobile = () => {
    if (
      (window.innerWidth >= 991 && !this.props.goToSupplier) ||
      this.props.compact
    ) {
      return;
    } else {
      this.props.toggleSupplier(this.props.index);
    }
  };

  openTab = () => {
    this.props.toggleSupplier(this.props.index);
    this.setState({ value: 1 });
  };

  openPhotoTab = () => {
    if (window.innerWidth <= 991) return;
    if (this.props.goToSupplier) return;
    this.props.toggleSupplier(this.props.index);
    this.setState({ value: 2 });
  };

  viewRooms = () => {
    this.setState({ value: 0 });
    this.props.toggleSupplier(this.props.index);
  };

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  handleChangeIndex = (newValue) => {
    this.setState({ value: newValue });
  };

  addToCart = (element, amount, callback, amountOfDays) => {
    this.props.addToCart(element, amount, callback, amountOfDays);
  };

  getDestinationName = () => {
    let destinationName = "";
    if (getDestination()) {
      if (getDestination().length > 1) {
        destinationName = "Multiple destinations";
        return destinationName;
      }
      getSystemSettings().multiDestination &&
        getSystemSettings().multiDestination.list.forEach((destination) => {
          if (
            getDestination().find(
              (dest) => parseInt(dest) === parseInt(destination.id)
            )
          ) {
            destinationName = destination.name;
          }
        });
    }
    return destinationName;
  };

  getCurrency = (displayType) => {
    let currency = null;
    switch (displayType) {
      case 1:
        currency = (
          <Currency
            displayType={displayType}
            strikeThrough={true}
            /*onlyOriginal={true}*/ float={true}
            value={this.props.element.OriginalFromPrice}
          />
        );
        break;
      case 2:
        currency = (
          <React.Fragment>
            {this.props.element.OriginalFromPrice > 0 &&
            this.props.element.OriginalFromPrice !==
              this.props.element.FromPrice ? (
              <Currency
                displayType={displayType}
                strikeThrough={true}
                /*onlyOriginal={true}*/ float={true}
                value={this.props.element.OriginalFromPrice}
              />
            ) : null}
            <Currency
              /*onlyOriginal={true}*/ float={true}
              value={this.props.element.FromPrice}
            />
          </React.Fragment>
        );
        break;
      case 3:
        break;
      default:
        break;
    }
    return currency;
  };

  getPricing = (pricing, position) => {
    let float = true;
    if (
      this.props.configuration &&
      this.props.configuration.config &&
      this.props.configuration.config.pricing
    ) {
      float = this.props.configuration.config.pricing.decimal;
    }
    let prices = null;
    switch (this.supplierPricing[position].type) {
      case "Savings":
        if (pricing.Savings) {
          prices = <div className="discount">{pricing.Savings.label}</div>;
        }
        break;
      case "FromPrice":
        prices = (
          <div className="finalPrice">
            <div className="finalPriceDetails">
              <Currency float={float} value={pricing.FromPrice} />
            </div>
          </div>
        );
        break;
      default:
        prices = null;
    }

    return prices;
  };

  setDrawerOpen = () => this.props.toggleSupplier(this.props.index);

  getItemClassName = () => {
    if (this.props.showUnspanned) {
      return "";
    }
    if (this.props.open !== null) {
      if (this.props.open === this.props.index) {
        return "opened";
      }
      return "closed";
    }
    if (this.props.onlyProduct !== undefined) {
      return "opened";
    }
    return "";
  };

  checkForOpacity = () => {
    const config = getSystemSettings(false).theme;

    const opacity = config.results && config.results.resultOpacity;

    if (
      opacity &&
      typeof opacity === "number" &&
      this.getItemClassName() === "closed"
    ) {
      return { opacity: opacity };
    }

    return null;
  };

  temporalFixImageDelivery = (delivery) => {
    delivery = delivery.replace('cm-pad_resize,', '');
    delivery = delivery.replace('h-120,', '');

    return delivery;
  }

  getFromLabel = () => {
    if (this.props.element && this.props.element.ProductList && this.props.element.ProductList.length < 2) return null;
    if (this.props.configuration && this.props.configuration.label_customization && this.props.configuration.label_customization.hide_from_label) return null;
    return <span>from</span>
  }

  render() {
    const {
      state,
      props,
      openIfMobile,
      openTab,
      handleChange,
      viewRooms,
      handleChangeIndex,
      addToCart,
      getDestinationName,
      getCurrency,
      getPricing,
      setDrawerOpen,
      getFromLabel
    } = this;
    const { index, element, showImages = true } = props;
    const { value } = state;

    if (element === undefined) {
      return null;
    } else {
      let descriptionClassName = "descriptionWrap";
      if (
        props.configuration &&
        props.configuration.config &&
        props.configuration.config.showMobileDescription
      ) {
        descriptionClassName = "descriptionWrap showOnMobile";
      }

      return (
        <>
          <Grid
            onClick={() => openIfMobile()}
            style={this.checkForOpacity()}
            key={index + "cell"}
            item
            xs={12}
            className={
              (props.showUnspanned
                ? " "
                : props.open !== null
                ? props.open === index
                  ? "opened "
                  : "closed "
                : "") + "item activities"
            }
          >
            <div
              className="multimedia"
              onClick={() => this.openPhotoTab()}
              style={!showImages ? { display: "none" } : {}}
            >
              <div style={{ backgroundImage: `url(${this.temporalFixImageDelivery(element.Image.Delivery)}${element.Image.FileName})`}} className="blurImg" />
              <img
                src={this.temporalFixImageDelivery(element.Image.Delivery) + element.Image.FileName}
                alt={element.ProductName}
              />
            </div>
            <div className="content">
              <div className="mainInfo">
                <div className="titleWrap">
                  <GroupTitle element={element} />
                </div>
                <div className={descriptionClassName}>
                  <Typography
                    variant="body2"
                    component="div"
                    className="description"
                  >
                    <TextTruncater
                      Function={
                        props &&
                        props.configuration &&
                        props.configuration.config &&
                        props.configuration.config.showDescriptionInline
                          ? null
                          : openTab.bind(this)
                      }
                      text={element.Description || element.LocationDescription}
                      sufix={"..."}
                      limit={100}
                      mode={"word"}
                    />
                  </Typography>
                </div>
              </div>
              <div className="pricing">
                <React.Fragment>
                  <div className="fromPrice">
                    {getFromLabel()}
                    {props.displayType
                      ? getCurrency(props.displayType)
                      : props.configuration &&
                        props.configuration.label_customization &&
                        props.configuration.label_customization.hide_from_price
                      ? null
                      : getPricing(element, "primaryPrice")}
                      {TaxesAndFeesText(element.ProductList[0])}
                  </div>
                  {getPricing(element, "upperPrice")}
                  {!props.showUnspanned ? (
                    <div className="main-cta">
                      <Button
                        onClick={() => viewRooms()}
                        className={
                          (index === props.open ? "opened " : " ") + "primary"
                        }
                      >
                        <IntlMessage
                          id={
                            props.configuration &&
                            props.configuration.label_customization &&
                            props.configuration.label_customization
                              .view_options_button
                              ? props.configuration.label_customization
                                  .view_options_button
                              : "activities.cell.view_options"
                          }
                        />
                        {props.open === index ? (
                          <SpotlioIcon size={16} icon={"feather-chevron-up"} />
                        ) : (
                          <SpotlioIcon
                            size={16}
                            icon={"feather-chevron-down"}
                          />
                        )}
                      </Button>
                    </div>
                  ) : null}
                </React.Fragment>
              </div>
            </div>
          </Grid>
          {window.innerWidth <= 991 ? (
            <Drawer
              disablePortal={true}
              onEscapeKeyDown={() => setDrawerOpen()}
              onBackdropClick={() => setDrawerOpen()}
              variant={"temporary"}
              anchor={"bottom"}
              open={props.open === index}
              className="mobileProductsModal"
              paperStyles={{
                backgroundColor: "#F4F4F9",
                padding: "0 !important",
              }}
            >
              <MobileMessage
                toggleButton={() => setDrawerOpen()}
                isBackButton
                currentStep={<GroupTitle element={element} noStyles />}
                pastSteps={[getDestinationName()]}
                arrivalDate={props.dateOfActivity}
                mode={"activities"}
              />
              <div className={"activitiesModalWrapper"}>
                <Grid
                  key={index + "cell"}
                  item
                  xs={12}
                  className={
                    (props.showUnspanned
                      ? " "
                      : props.open !== null
                      ? props.open === index
                        ? "opened "
                        : "closed "
                      : "") + "item activities"
                  }
                >
                  <div
                    className="multimedia"
                    style={!showImages ? { display: "none" } : {}}
                  >
                    <img
                      src={element.Image.Delivery + element.Image.FileName}
                      alt={element.ProductName}
                    />
                  </div>
                  <div className="content">
                    <div className="mainInfo">
                      <div className="titleWrap">
                        <GroupTitle element={element} />
                      </div>
                      <div className={descriptionClassName}>
                        <Typography
                          variant="body2"
                          component="div"
                          className="description"
                        >
                          <TextTruncater
                            Function={
                              props.configuration &&
                              props.configuration.showDescriptionInline
                                ? null
                                : openTab.bind(this)
                            }
                            text={
                              element.Description || element.LocationDescription
                            }
                            sufix={"..."}
                            limit={100}
                            mode={"word"}
                          />
                        </Typography>
                      </div>
                    </div>
                    <div className="pricing">
                      <React.Fragment>
                        <div className="fromPrice">
                          {getFromLabel()}
                          {props.displayType
                            ? getCurrency(props.displayType)
                            : props.configuration &&
                              props.configuration.label_customization &&
                              props.configuration.label_customization
                                .hide_from_price
                            ? null
                            : getPricing(element, "primaryPrice")}
                        </div>
                        {getPricing(element, "upperPrice")}
                        {!props.showUnspanned ? (
                          <div className="main-cta">
                            <Button
                              className={
                                (index === props.open ? "opened " : " ") +
                                "primary"
                              }
                            >
                              <IntlMessage
                                id={
                                  props.configuration &&
                                  props.configuration.label_customization &&
                                  props.configuration.label_customization
                                    .view_options_button
                                    ? props.configuration.label_customization
                                        .view_options_button
                                    : "activities.cell.view_options"
                                }
                              />
                              {props.open === index ? (
                                <SpotlioIcon
                                  size={16}
                                  icon={"feather-chevron-up"}
                                />
                              ) : (
                                <SpotlioIcon
                                  size={16}
                                  icon={"feather-chevron-down"}
                                />
                              )}
                            </Button>
                          </div>
                        ) : null}
                      </React.Fragment>
                    </div>
                  </div>
                </Grid>
                <CellActivitiesDetails
                  componentName={props.componentName}
                  packageCart={props.packageCart}
                  quantityPicker={props.quantityPicker}
                  addQuantity={props.addQuantity}
                  reduceQuantity={props.reduceQuantity}
                  minQuantity={props.minQuantity}
                  maxQuantity={props.maxQuantity}
                  dateOfActivity={props.dateOfActivity}
                  isPackage={props.isPackage}
                  displayType={props.displayType}
                  loading={props.loading}
                  configuration={props.configuration}
                  showImages={showImages}
                  compact={props.compact}
                  value={value}
                  handleChangeIndex={handleChangeIndex.bind(this)}
                  handleChange={handleChange.bind(this)}
                  addToCart={addToCart.bind(this)}
                  index={index}
                  element={element}
                  productCategoryId={props.productCategoryId}
                />
              </div>
              <div className={"bottomFixed"} onClick={() => setDrawerOpen()}>
                <SpotlioIcon icon="feather-x" /> Close
              </div>
            </Drawer>
          ) : null}
          {index === props.open ||
          props.onlyProduct !== undefined ||
          (props.showUnspanned && window.innerWidth > 991) ? (
            <CellActivitiesDetails
              componentName={props.componentName}
              packageCart={props.packageCart}
              addQuantity={props.addQuantity}
              reduceQuantity={props.reduceQuantity}
              quantityPicker={props.quantityPicker}
              minQuantity={props.minQuantity}
              maxQuantity={props.maxQuantity}
              dateOfActivity={props.dateOfActivity}
              isPackage={props.isPackage}
              displayType={props.displayType}
              loading={props.loading}
              configuration={props.configuration}
              showImages={showImages}
              compact={props.compact}
              value={value}
              handleChangeIndex={handleChangeIndex.bind(this)}
              handleChange={handleChange.bind(this)}
              addToCart={addToCart.bind(this)}
              index={index}
              element={element}
              productCategoryId={props.productCategoryId}
            />
          ) : null}
        </>
      );
    }

    // we need this on API
  }
}
